const changeIframeMode = mode => {
  const iframe = document.getElementById('resp-iframe');
  let size = 0;
  switch (mode) {
    case 'phone':
      // change to the size of iPhone 6/7/8
      size = '375px';
      iframe.style.width = size;
      iframe.style.marginLeft = `calc(50% - ${size}/2)`;
      break;
    case 'tablet':
      // change to the size of iPad
      size = '840px';
      iframe.style.width = size;
      iframe.style.marginLeft = `calc(50% - ${size}/2)`;
      break;
    default:
      iframe.style.width = '100%';
      iframe.style.marginLeft = '0';
      break;
  }
};

export { changeIframeMode };
